import {type BaseUIElement, UI, type WrittenUIElementOptions} from "../../stem-core/ui/UIBase";
import type {IconType} from "../../stem-core/ui/SimpleElements";
import {CheckmarkIcon, ChevronDownIcon, MinusIcon} from "./SVGElements.jsx";

const ICON_TO_CLASS: Record<string, typeof UI.Element<any>> = {
    "chevron-down": ChevronDownIcon,
    "minus": MinusIcon,
    "checkmark": CheckmarkIcon,
}

// Registered as stem's MakeIcon (blinkpay/theme/StyleConstants.ts), so it takes everything IconType allows -
// an element, a factory, or one of the names above - plus an icon class, which IconType has no arm for
export const BlinkMakeIcon = (icon: IconType | (new (options?: WrittenUIElementOptions) => BaseUIElement), options?: WrittenUIElementOptions) => {
    // TODO: this is common with the Stem implementation, reuse?
    if (!icon) {
        return null;
    }

    if (icon instanceof UI.Element) {
        return icon;
    }

    if ((icon as {prototype?: unknown}).prototype instanceof UI.Element) {
        return new (icon as new (options?: WrittenUIElementOptions) => BaseUIElement)(options);
    }

    if (typeof icon === "function") {
        // The class branch returned above, so what is left of the two callable arms is the factory
        return (icon as (options?: WrittenUIElementOptions) => BaseUIElement)(options);
    }

    // TODO: handle string mappings here
    // The branches above leave only a name from the table
    const IconClass = ICON_TO_CLASS[icon as string];
    if (IconClass) {
        return <IconClass {...options} />;
    }

    console.warn("Invalid icon:", icon);

    return null;
}